import { useHqScreenEvent } from './analytics';
import { HQ_NAME, TOOLS, TOOL_GROUPS } from './config';
import { HqLayout } from './layout';
import { HqLink } from './Link';
import { HqHarborBand, HqKicker, HqToolCard } from './ui';

export function ToolsPage() {
  useHqScreenEvent('HQ Tools Screen');

  return (
    <HqLayout
      title={`Free coparent tools: ${HQ_NAME}`}
      description='Custody calendars, expense splits, visitation logs, parenting plans, and child support estimates. Free starting tools for coparents. No account required.'
      path='/tools'
    >
      <HqKicker>Tools</HqKicker>
      <h1 className='mt-2 font-hq text-4xl font-medium tracking-tight sm:text-5xl'>
        Do the next useful thing
      </h1>
      <p className='mt-4 max-w-2xl text-lg leading-relaxed text-hq-muted'>
        Standalone tools. Use them without an account. Each one says what you leave with: a
        calendar file, a letter, a printable log, or a draft plan. Harbor is optional if you later
        want a shared calendar or ledger.
      </p>

      <div className='mt-12 space-y-12'>
        {TOOL_GROUPS.map((group) => {
          const tools = TOOLS.filter((tool) => tool.category === group.id);
          if (tools.length === 0) return null;
          return (
            <section key={group.id}>
              <h2 className='font-hq text-2xl font-medium tracking-tight text-hq-ink'>{group.label}</h2>
              <p className='mt-1 text-sm text-hq-muted'>{group.blurb}</p>
              <ul className='mt-5 grid gap-4 sm:grid-cols-2'>
                {tools.map((tool) => (
                  <li key={tool.id}>
                    <HqToolCard tool={tool} location='tools' />
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
      </div>

      <p className='mt-10 text-sm text-hq-muted'>
        Not sure where to start?{' '}
        <HqLink to='/' className='font-semibold text-hq-sage hover:underline'>
          Say where you are
        </HqLink>
        .
      </p>

      <div className='mt-14'>
        <HqHarborBand location='tools-band' />
      </div>
    </HqLayout>
  );
}
